document.addEventListener("DOMContentLoaded", function () {
  // Confirm link
  jQuery("form.confirmLink").submit(function () {
    var is_confirmed = confirm("Er du sikker på at du vil slette dette?");
    return is_confirmed;
  });

  /**

	// Sort table rows
	$( "#sortable" ).sortable({
		handle: ".handle",
		axis: "y"
	});
	$( "#sortable" ).disableSelection();
	$( "#sortable input").click(function() { $(this).focus(); });
 */

  /*
    // Display calendar
    jQuery(".date").datetimepicker({
        format: "DD.MM.YYYY",
        icons: {
            date: "fa fa-calendar",
        },
    });

    //display from to date calendar
    jQuery("#datetimepicker-from").datetimepicker({
        useCurrent: false, //Important! See issue #1075
        format: "DD.MM.YYYY",
        icons: {
            date: "fa fa-calendar",
        },
    });

    jQuery("#datetimepicker-to").datetimepicker({
        useCurrent: false, //Important! See issue #1075
        format: "DD.MM.YYYY",
        icons: {
            date: "fa fa-calendar",
        },
    });

  var maxDate = jQuery("#datetimepicker-to").val();
  var minDate = jQuery("#datetimepicker-from").val();
  if (maxDate) {
    jQuery("#datetimepicker-from").data("DateTimePicker").maxDate(maxDate);
  }
  if (minDate) {
    jQuery("#datetimepicker-to").data("DateTimePicker").minDate(minDate);
  }*/

  jQuery("#datetimepicker-from").on("blur", function (e) {
    this.form.submit();
  });

  jQuery("#datetimepicker-to").on("blur", function (e) {
    this.form.submit();
  });

  /**
   **/

  jQuery("#imageModal").on("show.bs.modal", function (event) {
    var button = jQuery(event.relatedTarget);
    var url = button.data("url");
    var modal = jQuery(this);
    modal.find(".modal-body #clicked-image").attr("src", url);
    modal.find(".modal-footer #imageid").val(button.data("id"));

    if (button.data("type").search("video") === -1) {
      jQuery("#clicked-image").replaceWith(
        '<img id="clicked-image" src="' + url + '" class="img-responsive" />'
      );
    } else {
      jQuery("#clicked-image").replaceWith(
        '<video controls id="clicked-image" src="' +
          url +
          '" class="img-responsive"></video>'
      );
    }
  });
});
